<template>
	<div id="app">
		<div v-if="is_connection">
			<div v-if="!is_auth">
				<Login />		
			</div>
			<div id="player-container" v-if="is_auth">
				<Player v-bind:can="playerState.can"/>
			</div>
			<div id="playlist-container" v-if="is_auth">
				<table class="play-list">
					<tr class="thead">
						<td class="date">Дата</td>
						<td class="artist-title">Исполнитель - Наименование</td>
						<td class="album">Год - Альбом</td>
						<td class="bitrate">kbps</td>
						<td class="duration">Длительность</td>
						<td class="download">Скачать</td>
					</tr>
					<template v-for="(year, p_key) in getPlaylistYears(track_list)">
						<tr class="tbody">
							<td class="year" colspan="6">{{ year }}</td>
						</tr>
						<tr v-bind:class="['tbody', 'track', {'selected-track': track.selected}]" v-for="track in track_list[year]">
							<td @click="onTrackSelected(track)" class="date">{{ track.track_date | formatDate }}</td>
							<td @click="onTrackSelected(track)" class="artist-title">{{ track.track_artist }} - {{ track.track_title }}</td>
							<td @click="onTrackSelected(track)" class="album">{{ track.track_year }} - {{ track.track_album }}</td>
							<td @click="onTrackSelected(track)" class="bitrate">~{{ track.track_bitrate }}</td>
							<td @click="onTrackSelected(track)" class="duration">{{ track.track_duration | formatTime }}</td>
							<td class="download"><a :href="track.url">Скачать</a></td>
						</tr>
					</template>
				</table>
			</div>
			<footer v-if="is_auth" id="info-bar" class="fixed-bottom">
				<div class="row">
					<div class="col-9 status">
						<img id="album-art" src="./assets/no_art.png" />
						<span id="track-status" v-scroll-to="'.selected-track'">{{ playerState.info }}</span>
						<br>
						<span id="player-status">{{ playerState.state }}</span>
					</div>
					<div class="col-3 status">
						<span id="tracks-count">
							Всего треков: {{ playerState.tracksInfo.count }}
						</span>
						<br>
						<span id="tracks-duration">
							Общеей длительностью: {{ playerState.tracksInfo.duration | formatTimeHours}}
						</span>
					</div>
				</div>
			</footer>
		</div>
		<div v-if="!is_connection" style="width: 100%;">
			<h1 class="text-center">{{ connection_message }}</h1>
		</div>
	</div>
</template>

<script>
const API_MSG_TYPE_OK					= 0x2007000;
const API_MSG_TYPE_ERROR				= 0x2007001;
const API_MSG_TYPE_USERADD 				= 0x2007002;
const API_MSG_TYPE_USERAUTH				= 0x2007003;
const API_MSG_TYPE_SESSION				= 0x2007004;
const API_MSG_TYPE_TRACKADD				= 0x2007005;
const API_MSG_TYPE_TRACKCHECK			= 0x2007006;
const API_MSG_TYPE_TRACKLIST			= 0x2007007;
const API_MSG_TYPE_TRACKLIST_UPDATES 	= 0x2007008;
const API_MSG_TYPE_PING					= 0x2007009;
const API_MSG_TYPE_PONG					= 0x2007009;

const API_ERR_GENERAL              = 0x2007100;
const API_ERR_USEREXISTS           = 0x2007101;
const API_ERR_USERDSNTEXISTS       = 0x2007102;
const API_ERR_SESSION_INCORRECT    = 0x2007103;
const API_ERR_TRACKEXISTS          = 0x2007104;
const API_ERR_TRACKDATA_COURRUPTED = 0x2007105;
const API_ERR_TRACKDSNTEXISTS      = 0x2007106;

const PLAYER_MODE_NORMAL = 200701;
const PLAYER_MODE_RANDOM = 200702;

import Login from './components/Login'
import Player from './components/Player'
import EventBus from './components/EventBus'
import Cookie from 'js-cookie'
import Config from './config.js'

export default {
	name: 'App',
	components: {
		Login,
		Player,
	},
	data: function () {
		return {
			tracks_url: Config.tracks_url,
			connection_message: 'Соединение с API закрыто. Песда всему',
			is_auth: false,
			is_connection: false,
			session: {
				session_id: '',
				session_username: '',
			},
			track_list: {
			},
			playerState: {
				mode:     PLAYER_MODE_NORMAL,
				state:    'Остановлено',
				info:     '',
				track:    {},
				tracksInfo: {
					count: 0,
					duration: 0.0,
				},
				playlist: {},
				can: {
					next: false,
					prev: false,
				},
			},
			pingIntervalId: null,
		}
	},
	methods: {
		trackListCompare: function(track_a, track_b) {
			if (track_a.track_date > track_b.track_date){
				return -1;
  			}
  			if (track_a.track_date < track_b.track_date){
    			return 1;
			}

			if (track_a.track_filename > track_b.track_filename) {
				return -1;
			} else {
				return 1;
			}
							
			return 0;
		},
		trackListSort: function() {
			var keys = [];

			for (var year in this.track_list) {
				if (this.track_list.hasOwnProperty(year)) {
					keys.push(year);
				}
			}

			for (var year in this.track_list) {
				this.track_list[year].sort(this.trackListCompare);
			}
		},
		calcTracksCount: function() {
			this.playerState.tracksInfo.count = 0;
			this.playerState.tracksInfo.duration = 0.0;
			for (var year in this.track_list) {
				this.playerState.tracksInfo.count += this.track_list[year].length;

				for (var track_id in this.track_list[year]) {
					this.playerState.tracksInfo.duration += this.track_list[year][track_id].track_duration;
				}
			}
		},
		getPlaylistYears(playlist) {
			var years = [];
			for (var year_index in playlist) {
				years.push(year_index);
			}
			years.sort().reverse();
			return years;
    	},
		onSocketDataReceived: function(msg) {
			var data = JSON.parse(msg.data);

			switch(data.msg_type) {
				case API_MSG_TYPE_ERROR: {
					switch(data.error_code) {
						case API_ERR_SESSION_INCORRECT: {
							localStorage.removeItem('user_session');
							localStorage.removeItem('user_name');
							Cookies.remove('user_session');
							this.is_auth = false;
							break;
						};
					}
					break;
				}
				case API_MSG_TYPE_SESSION: {
					if (!this.is_auth) {
						this.session.session_id 		= data.session_id;
						this.session.session_username 	= data.session_username;

						localStorage.setItem('user_session', 	this.session.session_id);
						localStorage.setItem('user_name', 		this.session.session_username);
						Cookie.set('user_session',  data.session_id);
						this.is_auth = true;
					}

					var req = {
						msg_type: 	API_MSG_TYPE_TRACKLIST,
						session_id: this.session.session_id,
					}

					this.$socket.sendObj(req);
					break;
				}
				case API_MSG_TYPE_TRACKLIST: {
					data.track_list.sort(function(a, b) {
			 	 		return b.track_date - a.track_date;
					});

					var track_list = {};

					for (var i in data.track_list) {
						var track = data.track_list[i];
						var date = new Date(track.track_date * 1000);
						var year = date.getFullYear();

						track.url = this.tracks_url + this.session.session_username + '/' + year + '/' + encodeURI(track.track_filename);
						track.selected = false;

						if (!Array.isArray(track_list[year])) {
							track_list[year] = new Array;
						}

						track_list[year].push(track);
					}

					this.track_list = track_list;

					this.calcTracksCount();
					this.trackListSort();

					var data = {
						msg_type: API_MSG_TYPE_TRACKLIST_UPDATES,
						session_id: this.session.session_id,
					};

					this.$socket.sendObj(data);
					break;
				}
				case API_MSG_TYPE_TRACKLIST_UPDATES: {
					for (var i in data.track_list) {
						var track = data.track_list[i];
						var date = new Date(track.track_date * 1000);
						var year = date.getFullYear();

						track.url = this.tracks_url + this.session.session_username + '/' + year + '/' + track.track_filename;
						track.selected = false;

						if (!Array.isArray(this.track_list[year])) {
							this.track_list[year] = new Array;
						}

						this.track_list[year].push(track);
					}

					this.trackListSort();
					this.calcTracksCount();

					if (this.playerState.playlist.length != 0) {
						this.playerState.playlist = this.constructPlayList();
						this.setCanState();
					}

					break;
				}
				case API_MSG_TYPE_PONG: {
					break;
				}
			}
		},
		onSocketConnectionOpen: function() {
			this.is_connection = true;

			this.session.session_id 		= localStorage.getItem('user_session');
			this.session.session_username 	= localStorage.getItem('user_name');
		
			if (this.session.session_id === null) {
				this.is_auth = false;
				return;
			}

			var data = {
				msg_type:         API_MSG_TYPE_SESSION,
				session_id:       this.session.session_id,
			};
			
			this.$socket.sendObj(data);

			this.pingIntervalId = setInterval(this.ping, Config.ping_interval);
		},
		ping: function() {
			var data = {
				msg_type: API_MSG_TYPE_PING,
			}

			this.$socket.sendObj(data);
		},
		onSocketConnectionClose: function() {
			clearInterval(this.pingIntervalId);
			this.is_connection = false;
		},
		shuffle(playlist) {
			var i = playlist.length;
			while (0 !== i) {
				var ri = Math.floor(Math.random() * i);
				i -= 1;
				var tmp = playlist[i];
				playlist[i] = playlist[ri];
				playlist[ri] = tmp;
			}
			return playlist;
		},
		constructPlayList: function() {
			var playlist = new Array;
			var years = new Array;
			
			for (var year in this.track_list) {
				years.push(year);
			}

			years.sort(function(a, b) {
				return b - a;
			});

			for (var year_i in years) {
				var year = years[year_i];

				for (var item_i in this.track_list[year]) {
					playlist.push(this.track_list[year][item_i]);
				}
			}

			if (this.playerState.mode == PLAYER_MODE_RANDOM) {
				playlist = this.shuffle(playlist);
			}

			return playlist;
		},
		setCanState: function() {
			var index = this.playerState.playlist.indexOf(this.playerState.track);

			if (index > 0) {
				this.playerState.can.next = true;
				this.playerState.can.prev = true;
			}

			if (index == 0) {
				this.playerState.can.next = true;
				this.playerState.can.prev = false;				
			}

			if (index == this.playerState.playlist.length - 1) {
				this.playerState.can.next = false;
				this.playerState.can.prev = true;
			}			
		},
		selectTrack: function(index) {
			var track = this.playerState.playlist[index];

			if (this.playerState.track.hasOwnProperty('selected')) {
				this.playerState.track.selected = false;
			}

			this.playerState.track = track;
			this.playerState.track.selected = true;

			this.setCanState();
			EventBus.$emit('playtrack', track.url);
		},
		onTrackSelected: function(item) {
			this.playerState.playlist = this.constructPlayList();

			var index = this.playerState.playlist.indexOf(item);
			
			if (this.playerState.mode == PLAYER_MODE_RANDOM) {
				let track = this.playerState.playlist[0];
				this.playerState.playlist[0] = this.playerState.playlist[index];
				this.playerState.playlist[index] = track;
				index = 0;
			}

			this.selectTrack(index);
		},
		onPlayerModeChanged: function(mode) {
			this.playerState.mode = mode;
			this.playerState.playlist = this.constructPlayList();

			var index = this.playerState.playlist.indexOf(this.playerState.track);
			if (index != -1) {
				if (mode == PLAYER_MODE_RANDOM) {
					let track = this.playerState.playlist[0];
					this.playerState.playlist[0] = this.playerState.playlist[index];
					this.playerState.playlist[index] = track;
					index = 0;
				}
			}
			this.setCanState();
		},
		onPlayerActionPlay: function() {
			this.playerState.state = 'Воспроизведение';
			this.playerState.info = this.playerState.track.track_artist + ' - ' + this.playerState.track.track_title;
		},
		onPlayerActionPause: function() {
			this.playerState.state = 'Пауза';
		},
		onPlayerActionEnd: function() {
			this.playerState.state = 'Остановлено';
			this.onPlayerActionNext();
		},
		onPlayerActionNext: function() {
			var index = this.playerState.playlist.indexOf(this.playerState.track);
			index++;

			if (index < this.playerState.playlist.length) {
				this.selectTrack(index);				
			}
		},
		onPlayerActionPrev: function() {
			var index = this.playerState.playlist.indexOf(this.playerState.track);
			console.log(index);
			index--;
			if (index >= 0) {
				this.selectTrack(index);				
			}
		},
	},
	created: function() {
		this.$connect();
		this.$options.sockets.onopen = this.onSocketConnectionOpen;
		this.$options.sockets.onmessage = this.onSocketDataReceived;
		this.$options.sockets.onclose = this.onSocketConnectionClose;

		EventBus.$on('onLogin', (data) => {
			var data = {
				msg_type:         API_MSG_TYPE_USERAUTH,
				user_name:        data.username,
				user_password:    data.password,
			};

			this.$socket.sendObj(data);
		});

		EventBus.$on('playermodechanged', this.onPlayerModeChanged);
		EventBus.$on('playerplay', this.onPlayerActionPlay);
		EventBus.$on('playerpause', this.onPlayerActionPause);
		EventBus.$on('playerend', this.onPlayerActionEnd);
		EventBus.$on('onnextbtn', this.onPlayerActionNext);
		EventBus.$on('onprevbtn', this.onPlayerActionPrev);
	},
};
</script>

<style>
html,
body {
	color: #BABDB6;
  	background-color: #16191A;
  	font-size: 9pt;
	font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
}

html {
	height: 100%;
	width: 100%;
	overflow-y: scroll;
}

#player-container {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 47px;
    background-color: black;
    padding-left: 5%;
    padding-right: 5%;
    min-width: 1024px;
    z-index: 10;
}

#playlist-container {
	background-color: #2E3436;
	padding-top: 60px;
	padding-bottom: 60px;
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
    padding-left: 100px;
    padding-right: 100px;
    height: 100%;
	color: #BABDB6;
  	background-color: #16191A;
}

#info-bar {
	background-color: black;
	padding: 10px;
}

#info-bar #album-art {
	height: 36px;
	float: left;
	margin-right: 10px;
}

#info-bar #track-status {
	cursor: pointer;
}

.play-list {
	width: 100%;
}

.play-list .thead {
	background-color: #1F2324;
	color: white;
}

.play-list .track:hover {
	background-color: #1F2324;
	cursor: pointer;
}

.play-list .active {
	background-color: #1F2324;
}

.play-list .active:hover {
	background-color: #1F2324;
	cursor: pointer;
}

.play-list .tbody .year {
	border-bottom: 1px solid #878D80;
}

.play-list .selected-track {
	background-color: #1F2324;
}

.play-list .thead td {
	padding-top: 2px;
	padding-bottom: 2px;
	padding-left: 8px;
	padding-right: 8px;
}

.play-list .tbody td {
	padding-top: 2px;
	padding-bottom: 2px;
	padding-left: 8px;
	padding-right: 8px;
}

.play-list .tbody .date {
	width: 180px;
	padding-left: 30px;
}

.play-list .thead .date {
	width: 180px;
}

.play-list .thead .artist-title {
}

.play-list .thead .bitrate {
	width: 60px;
}

.play-list .thead .duration {
	width: 60px;
	text-align: right;
}

.play-list .tbody .duration {
	text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/App.vue